import { FC, useEffect, useRef } from 'react';
import { useTenantCheckInfo } from '@/common/hook/useTenantCheckInfo';
import TaskCreateDrawer from '@/common/components/business/ExpandStore/TaskCreateDrawer';
import CircleTaskCreateDrawer from 'src/views/expandstore/pages/expansioncircletask/components/Edit/index';
import SemirTaskCreateDrawer from '@/views/expandstore/pages/expansioncirclesenmatask/components/Edit';
import ExpansionFranchiseeCircleTaskEditDrawer from '@/views/expandstore/pages/expansionFranchiseeCircleTask/pages/edit/Drawer';
import LocxxTaskCreateDrawer from '@/views/expandstore/pages/expansionlocxxtask/components/LocxxTaskCreateDrawer';
import { useMethods } from '@lhb/hook';

/**
 * @Description 自动适配各种拓店任务模板下的创建
 *
 * 用法
 *
 * import AdaptiveTaskCreate from '@/common/components/business/ExpandStore/AdaptiveTaskCreate';
 *
 *      const [showCreateDrawer, setShowCreateDrawer] = useState<boolean>(false); // 创建拓店任务是否可见
 *
        showCreateDrawer && <AdaptiveTaskCreate
          showCreateDrawer={showCreateDrawer}
          setShowCreateDrawer={setShowCreateDrawer}
          businessInfo={detail}
          isBusiness={true}
          refresh={getDetail}
        />
 *
 */

const AdaptiveTaskCreate: FC<{
  showCreateDrawer,
  setShowCreateDrawer,
  businessInfo, // 商圈信息，加盟商任务模板忽略该字段
  isBusiness, // 是否来自商圈页，加盟商任务模板忽略该字段
  refresh
}> = ({
  showCreateDrawer,
  setShowCreateDrawer,
  businessInfo,
  isBusiness,
  refresh
}) => {

  const { taskTemplateCode } = useTenantCheckInfo();

  const standardAndClusterEditRef = useRef<any>();

  const methods = useMethods({
    /** 加盟+直营模板、Locxx 模板的关闭处理 */
    handleClose() {
      setShowCreateDrawer(false);
    },
  });

  useEffect(() => {
    if (showCreateDrawer && ['standardAndClusterA', 'standardAndClusterB'].includes(taskTemplateCode)) {
      standardAndClusterEditRef.current?.init();
    }
  }, [showCreateDrawer, taskTemplateCode]);

  return (
    <>
      {/* 加盟任务模板 */}
      {taskTemplateCode === 'standardA' && <TaskCreateDrawer
        showDrawer={showCreateDrawer}
        setShowDrawer={setShowCreateDrawer}
        refresh={refresh}
      />}
      {/* 直营 */}
      {['clusterA', 'clusterB'].includes(taskTemplateCode) && <CircleTaskCreateDrawer
        showDrawer={showCreateDrawer}
        setShowDrawer={setShowCreateDrawer}
        businessInfo={businessInfo}
        isBusiness={isBusiness}
        refresh={refresh}
      />}
      {/* 森马模板 */}
      {taskTemplateCode === 'clusterC' && <SemirTaskCreateDrawer
        showDrawer={showCreateDrawer}
        setShowDrawer={setShowCreateDrawer}
        businessInfo={businessInfo}
        isBusiness={isBusiness}
        refresh={refresh}
      />}
      {/* 加盟+直营A（基诺浦）、加盟+直营B（一鸣） */}
      {['standardAndClusterA', 'standardAndClusterB'].includes(taskTemplateCode) && <ExpansionFranchiseeCircleTaskEditDrawer
        ref={standardAndClusterEditRef}
        businessInfo={businessInfo}
        isBusiness={isBusiness}
        reload={refresh}
        onClose={methods.handleClose}/>}
      {/* Locxx 直营任务 */}
      {taskTemplateCode === 'locxxA' && <LocxxTaskCreateDrawer
        open={showCreateDrawer}
        onClose={methods.handleClose}
        onSuccess={refresh}
        businessInfo={businessInfo}
        isBusiness={isBusiness}
      />}
    </>
  );
};

export default AdaptiveTaskCreate;
